import {
  LEGALSITEPLAN_LOADING,
  GET_LEGALSITEPLAN,
  GET_LEGALSITEPLAN_SUCCESS,
  GET_LEGALSITEPLAN_FAIL,
  ADD_LEGALSITEPLAN_SUCCESS,
  ADD_LEGALSITEPLAN_FAIL,
  DELETE_LEGALSITEPLAN_SUCCESS,
  DELETE_LEGALSITEPLAN_FAIL,
  UPDATE_LEGALSITEPLAN_SUCCESS,
  UPDATE_LEGALSITEPLAN_FAIL,
  LEGALSITEPLAN_RESET
} from "./actionType";

const INIT_STATE = {
  legalSiteplans: [],
  error: {},
};

const LegalSiteplan = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_LEGALSITEPLAN_SUCCESS:
      switch (action.payload.actionType) {
        case GET_LEGALSITEPLAN:
          return {
            ...state,
            legalSiteplans: action.payload.data,
            isLegalSiteplanCreated: false,
            isLegalSiteplanSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_LEGALSITEPLAN_FAIL:
      switch (action.payload.actionType) {
        case GET_LEGALSITEPLAN_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isLegalSiteplanCreated: false,
            isLegalSiteplanSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_LEGALSITEPLAN: {
      return {
        ...state,
        isLegalSiteplanCreated: false,
        loading: true,
      };
    }

    case LEGALSITEPLAN_LOADING: {
      return {
        ...state,
        isLegalSiteplanCreated: false,
        loading: true,
      };
    }

    case ADD_LEGALSITEPLAN_SUCCESS:
      return {
        ...state,
        isLegalSiteplanCreated: true,
        loading: false,
        legalSiteplans: [action.payload.data, ...state.legalSiteplans],
      };

    case ADD_LEGALSITEPLAN_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_LEGALSITEPLAN_SUCCESS:
      return {
        ...state,
        loading: false,
        legalSiteplans: state.legalSiteplans.filter(
          legalSiteplan => legalSiteplan.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_LEGALSITEPLAN_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_LEGALSITEPLAN_SUCCESS:
      return {
        ...state,
        loading: false,
        legalSiteplans: state.legalSiteplans.map(legalSiteplan =>
          legalSiteplan.id.toString() === action.payload.data.id.toString() ? { ...legalSiteplan, ...action.payload.data } : legalSiteplan
        ),
      };

    case UPDATE_LEGALSITEPLAN_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case LEGALSITEPLAN_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default LegalSiteplan;